/* eslint-disable max-lines */
import { CUSTOMER_JOURNEYS, LOCALE_CODES } from '@constants';
import { translate } from '@utils/locales';

export const getBlueLightInfoTabs = (locale: string = LOCALE_CODES.US) => {
	const BLUE_LIGHT_INFO_TABS = [
		{
			title: translate('for-home', locale),
			list: [
				{ description: translate('blue-light-description-screenbound', locale), checkmark: true },
				{ description: translate('blue-light-description-relieving', locale), checkmark: true },
				{ description: translate('blue-light-description-refreshing', locale), checkmark: true },
				{ description: translate('blue-light-description-preventive', locale), checkmark: true },
			],
		},
		{
			title: translate('for-work', locale),
			list: [
				{ description: translate('blue-light-description-sleep-enhancing', locale), checkmark: true },
				{ description: translate('blue-light-description-relaxing', locale), checkmark: true },
				{ description: translate('blue-light-description-gamer-friendly', locale), checkmark: true },
				{ description: translate('blue-light-description-childproof', locale), checkmark: true },
			],
		},
		{
			title: translate('rx-type-text-sinlge-vision', locale),
			list: [
				{ description: translate('blue-light-description-polycarbonate', locale), checkmark: true },
				{ description: translate('blue-light-description-treated', locale), checkmark: true },
				{ description: translate('blue-light-description-add-on', locale), checkmark: true },
			],
		},
		{
			title: translate('progressives', locale),
			list: [
				{ description: translate('blue-light-description-multifocal', locale), checkmark: true },
				{ description: translate('blue-light-description-progressive', locale), checkmark: true },
				{ description: translate('blue-light-description-add-on-249', locale), checkmark: true },
			],
		},
	];
	return BLUE_LIGHT_INFO_TABS;
};

export const getDefaultInfoTabs = (locale: string = LOCALE_CODES.US) => {
	const DEFAULT_INFO_TABS = [
		{
			title: translate('rx-type-text-sinlge-vision', locale),
			list: [
				{ description: translate('single-vision-tab-diopter-range', locale), checkmark: true },
				{ description: translate('single-vision-tab-lens-focus-range', locale), checkmark: true },
				{ description: translate('single-vision-tab-lens-uv-protection', locale), checkmark: true },
				{ description: translate('single-vision-tab-lens-feature-ar-coating', locale), checkmark: true },
			],
		},
		{
			title: translate('progressives', locale),
			list: [
				{ description: translate('progressives-tab-digital-freeform', locale), checkmark: true },
				{ description: translate('progressives-tab-bifocal-upgrade', locale), checkmark: true },
				{ description: translate('progressives-tab-add-suitable', locale), checkmark: true },
				{ description: translate('progressives-tab-varifocal-range', locale), checkmark: true },
				{ description: translate('progressives-tab-premium-coating', locale), checkmark: true },
			],
		},
		{
			title: translate('readers', locale),
			list: [
				{ description: translate('readers-magnifying', locale), checkmark: true },
				{ description: translate('readers-noRx', locale), checkmark: true },
				{ description: translate('readers-strengthRange', locale), checkmark: true },
				{ description: translate('readers-premiumCoating', locale), checkmark: true },
			],
		},
	];
	return DEFAULT_INFO_TABS;
};

export const getVarifocalInfoTabs = (locale: string = LOCALE_CODES.US) => {
	const VARIFOCAL_INFO_TABS = [
		{
			title: translate('rx-type-text-sinlge-vision', locale),
			list: [
				{ description: translate('single-vision-tab-diopter-range', locale), checkmark: true },
				{ description: translate('single-vision-tab-lens-focus-range', locale), checkmark: true },
				{ description: translate('single-vision-tab-lens-uv-protection', locale), checkmark: true },
				{ description: translate('single-vision-tab-lens-feature-ar-coating', locale), checkmark: true },
			],
		},
		{
			title: translate('varifocals', locale),
			list: [
				{ description: translate('progressives-tab-digital-freeform', locale), checkmark: true },
				{ description: translate('progressives-tab-bifocal-upgrade', locale), checkmark: true },
				{ description: translate('progressives-tab-add-suitable', locale), checkmark: true },
				{ description: translate('progressives-tab-varifocal-range', locale), checkmark: true },
				{ description: translate('progressives-tab-premium-coating', locale), checkmark: true },
			],
		},
		{
			title: translate('readers', locale),
			list: [
				{ description: translate('readers-magnifying', locale), checkmark: true },
				{ description: translate('readers-noRx', locale), checkmark: true },
				{ description: translate('readers-strengthRange', locale), checkmark: true },
				{ description: translate('readers-premiumCoating', locale), checkmark: true },
			],
		},
	];
	return VARIFOCAL_INFO_TABS;
};

export const getLensInfoTabs = (locale: string = LOCALE_CODES.US) => {
	const LENS_INFO_TABS = [
		{
			title: translate('premium-plus', locale),
			list: [{ description: translate('lens-tab-premium-highIndex', locale), checkmark: true }],
		},
		{
			title: translate('blue-light-filtering-2', locale),
			list: [{ description: translate('lens-tab-blueLight', locale), checkmark: true }],
		},
		{
			title: translate('light-responsive', locale),
			list: [{ description: translate('lens-tab-light-responsive', locale), checkmark: true }],
		},
	];
	return LENS_INFO_TABS;
};

export const getSunLensInfoTabs = (locale: string = LOCALE_CODES.US) => {
	const SUN_LENS_INFO_TABS = [
		{
			title: translate('polarized', locale),
			list: [
				{ description: translate('sun-lens-tab-polarized-standard', locale), checkmark: true },
				{ description: translate('sun-lens-tab-polarized-glare', locale), checkmark: true },
				{ description: translate('sun-lens-tab-polarized-colors', locale), checkmark: true },
			],
		},
		{
			title: translate('reflective', locale),
			list: [
				{ description: translate('sun-lens-tab-polarized-standard', locale), checkmark: true },
				{ description: translate('sun-lens-tab-reflective-glare', locale), checkmark: true },
				{ description: translate('sun-lens-tab-reflective-clarity', locale), checkmark: true },
				{ description: translate('sun-lens-tab-reflective-anonymity', locale), checkmark: true },
			],
		},
		{
			title: translate('rx-type-text-sinlge-vision', locale),
			list: [
				{ description: translate('sun-lens-tab-polarized-standard', locale), checkmark: true },
				{ description: translate('blue-light-description-polycarbonate', locale), checkmark: true },
				{ description: translate('blue-light-description-treated', locale), checkmark: true },
				{
					description: translate('sun-lens-tab-single-vision-price', locale),
					description_ca: translate('sun-lens-tab-single-vision-price-ca', locale),
					description_au: translate('sun-lens-tab-single-vision-price-au', locale),
					description_gb: translate('sun-lens-tab-single-vision-price-gb', locale),
					description_mx: translate('sun-lens-tab-single-vision-price-mx', locale),
					checkmark: true,
				},
			],
		},
		{
			title: translate('progressives', locale),
			list: [
				{ description: translate('sun-lens-tab-polarized-standard', locale), checkmark: true },
				{ description: translate('blue-light-description-multifocal', locale), checkmark: true },
				{ description: translate('blue-light-description-progressive', locale), checkmark: true },
				{
					description: translate('sun-lens-tab-progressives-price', locale),
					description_ca: translate('sun-lens-tab-progressives-price-ca', locale),
					description_au: translate('sun-lens-tab-progressives-price-au', locale),
					description_gb: translate('sun-lens-tab-progressives-price-gb', locale),
					description_mx: translate('sun-lens-tab-progressives-price-mx', locale),
					checkmark: true,
				},
			],
		},
	];
	return SUN_LENS_INFO_TABS;
};

// Journey-Specific Info
export const getInfoModuleData = (locale: string) => {
	const INFO_MODULE_DATA = {
		[CUSTOMER_JOURNEYS.BLUELIGHT]: {
			id: 'blue_light_info_module',
			cmsSlug: 'blue-light-offering',
			tabs: getBlueLightInfoTabs(locale),
			title: translate('blue-light-offerings', locale),
		},
		[CUSTOMER_JOURNEYS.SUNGLASSES]: {
			id: 'sun_lens_info_module',
			cmsSlug: 'sun-lens-offering',
			tabs: getSunLensInfoTabs(locale),
			title: translate('sun-lens-offerings', locale),
		},
		[CUSTOMER_JOURNEYS.EYEGLASSES]: {
			id: 'lens_lineup_info_module',
			cmsSlug: 'lens-lineup',
			tabs: [...getDefaultInfoTabs(locale), ...getLensInfoTabs(locale)],
			title: translate('rx-lens-lineup', locale),
		},
	};
	return INFO_MODULE_DATA;
};

export const getSubscriptionInfoTabs = (locale: string) => {
	const SUBSCRIPTION_INFO_TABS = [
		{
			v2: true,
			title: translate('all-about-subscriptions', locale),
			list: [
				{
					description: translate('subscription-info-description', locale),
					checkmark: true,
					justify: true,
				},
				{
					description: translate('subscription-info-description-p2', locale),
					checkmark: true,
					justify: true,
				},
			],
		},
	];
	return SUBSCRIPTION_INFO_TABS;
};
